export const colors = {
    // Core pink
    corePink: '#F8E6EF',

    // Secondary pink palette
    secondary1: '#F1D1D4',
    secondary2: '#EFBDCD',
    secondary3: '#EAA6B4',
    secondary4: '#F094A0',
    secondary5: '#DE86A7',
    secondary6: '#E06B7F',

    // Tertiary Colors - Pink
    pink1: '#D55382',
    pink2: '#C6316E',
    pink3: '#EC646D',
    pink4: '#DC4B52',
    // Copied to red
    pink5: '#C42929',
    pink6: '#7A164B',

    // Tertiary Colors - Purple
    purple1: '#C7BCCF',
    purple2: '#A092AF',
    purple3: '#A190C0',
    purple4: '#7A6A8D',
    purple5: '#5F4C75',
    purple6: '#3C2B52',

    // Tertiary Colors - Gray
    gray1: '#DBD9D6',
    gray2: '#8A8C8C',
    gray3: '#555759',
    gray4: '#13181F',

    // Tertiary Colors - Beige
    beige1: '#E8D6D1',
    beige2: '#D5BFB8',
    beige3: '#C8A882',
    beige4: '#A97C59',

    // Not in Graphic Profile
    black: '#000000',
    gray: '#7C7C7C',
    veryLightGray: '#F8F8F8',
    white: '#FFFFFF',
    pink: '#ED80A8',
    yellow: '#F0AD4E',
    yellow1: '#DA9F4B',
    green: '#68A823',
    // Same as pink5
    red: '#C42929',

    hover: 'rgba(0, 0, 0, 0.015)',
    active: 'rgba(0, 0, 0, 0.025)',
    transparent: {
        white50: '#ffffff88',
        white67: '#ffffffaa',
    },

} as const;
